<template>
    <div>
        <div class="rules__header rules__header-staff">
            <div class="text-size-18 text-bold rules__header-wrapper">
                <div class="rules__header-left">
					<span class="ts-name --staff">
						<span>Пользователи</span>
						<div class="count">
							{{ userTotal }}
						</div>
					</span>
                </div>
                <div class="rules__header-right" v-if="usersGroupedCurrentIndex != 'dismiss' &&usersGroupedCurrentIndex != 'refuse' && (userCurrent.access_rights.is_owner || userCurrent.is_can_dismiss)">
					<span class="ss-name --staff">
						{{usersGroupedCurrent.name}}
					</span>
					<div class="df">
	                    <div class="rules__btn" @click="openAddWorker([])" >
	                        <span class="elem">
	                            <span class="i i-staff4"></span>
	                            Добавить пользователя
	                        </span>
	                    </div>
					</div>
                </div>
            </div>
        </div>
        <div class="content moderator-rules">
            <div class="container staff-container">

				<aside-sticky :marginTop="88" :marginBottom="0" >
		          <aside class="aside aside--left aside--catalog" ref="aside">
					  	<div class="aside__sticky" id="aside-sticky">
						    <div class="nav nav--city" >
							  <div class="nav-wrapper"  v-if="usersGrouped.length">
								  <draggable :forceFallback="true" :disabled="(!canDrag || popups.addRule.show) && !userCurrent.access_rights.is_owner"
				                              element="ul"
				                             v-model="usersGrouped"
				                             :move="dragStatus"
											 @end="dragSaveGrouped"
				                             :animation="150"
				                             :touchStartThreshold="3"
				                             :delay="10"
				                             class="nav-list">
				                  <li class="nav-list-item" v-for="(department, index) in usersGrouped" :key="department.id">
				                      <a href="javascript:void(0)" @mouseup="setUsersGroupedCurrentIndex(department.id)" class="nav-list-item-link" :class="{active: department.id == usersGroupedCurrent.id && usersGroupedCurrentIndex !== 'dismiss' && usersGroupedCurrentIndex !== 'refuse', 'can-hover': false, 'current': false }">
				                          <span class="cat-name">{{ department.name }}</span>
                                          <span v-if="tumblers.staffEditable.value  && userCurrent.access_rights.is_owner" class="i-wrapper edit-btn" @click="openStaffGroup(department)">
				                              <span class="i i-pencil2" @click.prevent=""></span>
				                              <span class="i i-pencil2-active" @click.prevent=""></span>
				                          </span>
                                          <div class="count" v-else>
										  	{{ department.users.length }}
										  </div>
				                      </a>
				                  </li>
				                  </draggable>
                                  <div class="nav-list-item">
                                      <a href="javascript:void(0)" @mouseup="setUsersGroupedCurrentIndex('refuse')" class="nav-list-item-link" :class="{active: usersGroupedCurrentIndex == 'refuse', 'can-hover': false, 'current': false }">
                                          <span class="cat-name">Отклоненные</span>
                                          <div class="count">
                                              {{ refuseUsers.length }}
                                          </div>
                                      </a>
                                  </div>
                                  <div class="nav-list-item">
                                      <a href="javascript:void(0)" @mouseup="setUsersGroupedCurrentIndex('dismiss')" class="nav-list-item-link" :class="{active: usersGroupedCurrentIndex == 'dismiss', 'can-hover': false, 'current': false }">
                                          <span class="cat-name">Заблокированные</span>
                                          <div class="count">
                                              {{ dismissUsers.length }}
                                          </div>
                                      </a>
                                  </div>
							  </div>
							  <div class="add-section__wrap" @click="openStaffGroup">
						          <div class="add-section">
						              <span class="i i-plus8"></span>
						              <span class="i i-plus8-active"></span>
						          </div>
						      </div>
							</div>
						</div>
		          </aside>
		        </aside-sticky>

		        <div class="container__full container-scroll container__right container__staff" v-if="usersGrouped.length" :style="{minHeight: minHeight + 'px' }">
					<div class="staff__table-head">
						<div class="text-size-xs text-color-grey mr2" style="width: 326px;">
                            Пользователь
						</div>
						<div class="text-size-xs text-color-grey mr2 text-center" style="width: 68px;">
							Разделы
						</div>
						<div class="text-size-xs text-color-grey mr-auto text-center" style="width: 254px;">
							Email
						</div>
						<div class="head-item text-right" style="width: 102px">
							Телефон
						</div>
					</div>

					<div class="workers-list" v-if="usersGroupedCurrent.users.length !== 0">
						<div :id="'user_'+user.id" class="worker" v-for="user in usersGroupedCurrent.users" :key="user.id">
							<div class="worker-name">
								<span class="text-size-m">{{user.name}}</span>
								<span class="text-color-grey text-size-xs">{{user.post}}</span>
							</div>
							<template  v-if="tumblers.staffEditable.value && !user.banned && user.status === 'active'">
								<div class="accesses" >
    								<span class="i-wrapper" @click="openAddWorker(user)">
        								<span class="pencil"></span>
        								<span class="pencil-active"></span>
        							</span>
    							</div>
							</template>

							<template v-else-if="user.banned && usersGroupedCurrentIndex !== 'refuse'">
								<div class="accesses">
	    							<div class="user-fired">
	    								<tooltip
	    									:direction="'left-center-direction'"
	    									:isBtnClose="false"
	    									:add-style="{width: 'auto'}">
	    									<span slot="tooltipBtn">
	    										<div class="i i-stop i--dark-trans" ></div>
	    									</span>

	    									<div slot="tooltipContent" style="white-space: nowrap">
	    										Пользователь заблокирован
	    									</div>
	    								</tooltip>
	    							</div>
								</div>
							</template>
							<template v-else-if="user.status === 'active'">
								<tooltip
	                                v-if="Object.keys(user.rights).length>0"
									:direction="'bottom-center-direction'"
									:add-class-wrap="'accesses'"
									:isChangeablePos="false"
                                    @tooltipshow="addHeight"
                                    @close="removeHeight"
									:add-style="{width: 230 + 'px'}">
									<span slot="tooltipBtn">
										<div class="num">
											{{Object.keys(user.rights).length}}
										</div>
									</span>

									<div slot="tooltipContent">
										<template v-for="sect in topSections">
											<div v-if="user.rights[sect.id]" class="flex-row" :key="user.id+'_'+sect.id" >
												<div class="text-bold text-size-s">
													{{sect.name}}
												</div>
												<div class="access" :class="accessClass(user.rights[sect.id])">
												  {{ accessTitle(user.rights[sect.id]) }}
												</div>
											</div>
										</template>
									</div>
								</tooltip>
								<div class="accesses" v-if="Object.keys(user.rights).length < 1">
	                                <div class="num">0</div>
	                            </div>
							</template>
							<template v-else>
								<div class="accesses">
	                                <div class="status check" v-if="user.status === 'uploaded'">
										НА ПРОВЕРКЕ
	                                </div>
									<div class="status approval" v-else-if="user.status === 'approval'">
										НА ОДОБРЕНИЕ
	                                </div>
									<div class="status wait" v-else>
										ЖДЁМ ДОГОВОР
	                                </div>
	                            </div>
							</template>

							<div class="worker-email mr-auto">
								<span v-if="user.emailWork">{{user.emailWork}}</span>
								<span v-else>-</span>
								<div class="text-color-grey text-size-xs">
									{{user.email}}
								</div>
							</div>
							<div class="worker-phone text-right mr0">
								{{user.phone}}
							</div>

							<button @click="openAddWorker(user)" type="button" class="btn btn--blue" v-if="user.status === 'uploaded' && userCurrent.is_can_dismiss && usersGroupedCurrentIndex !== 'dismiss' && usersGroupedCurrentIndex !== 'refuse'">Проверить</button>
							<button @click="openAddWorker(user)" type="button" class="btn btn--red" v-if="user.status === 'new' && userCurrent.is_can_dismiss && usersGroupedCurrentIndex !== 'dismiss' && usersGroupedCurrentIndex !== 'refuse'">Отклонить</button>
							<button @click="openAddWorker(user)" type="button" class="btn btn--blue" v-if="user.status === 'approval' && userCurrent.access_rights.is_owner && usersGroupedCurrentIndex !== 'dismiss' && usersGroupedCurrentIndex !== 'refuse'">Одобрить</button>
						</div>
					</div>
		        </div>
            </div>
        </div>
        <popup :is-set-styled="false" :show="popups.staffGroup.show" :name="popups.staffGroup.name" :width="400" :add-class="'add-cat'">
            <staff-group></staff-group>
        </popup>

        <popup :is-set-styled="false" :is-btn-close="false" :show="popups.removeStaffGroupError.show" :name="popups.removeStaffGroupError.name" :width="400" >
            <remove-staff-group-error></remove-staff-group-error>
        </popup>

        <popup @close="clearFormUser" :is-set-styled="false" :show="popups.addWorker.show" :name="popups.addWorker.name" :width="800" :add-class="'add-worker'">
            <add-worker :usersGroupedCurrentIndex="usersGroupedCurrentIndex" @change="setUsersGroupedCurrentIndex"></add-worker>
        </popup>

        <popup :is-set-styled="false" :show="popups.dismissWorker.show" :name="popups.dismissWorker.name" :width="430" >
            <dismiss-worker></dismiss-worker>
        </popup>

        <popup :is-set-styled="false" :show="popups.refuseWorker.show" :name="popups.refuseWorker.name" :width="430" >
            <refuse-worker></refuse-worker>
        </popup>

        <popup :is-set-styled="false" :is-btn-close="true" :show="popups.kickUnReadAll.show" :name="popups.kickUnReadAll.name" :width="400" >
            <kick-un-read-all></kick-un-read-all>
        </popup>

		<popup @close="openAddWorker" :is-set-styled="false" :is-btn-close="true" :show="popups.createUser.show" :name="popups.createUser.name" :width="512" >
            <create-user @change="setUsersGroupedCurrentIndex"></create-user>
        </popup>

		<popup :is-set-styled="false" :is-btn-close="false" :show="popups.pdfViewer.show" :name="popups.pdfViewer.name" :add-class="'pdf-viewer__wrapper'">
            <pdf-viewer></pdf-viewer>
        </popup>
    </div>
</template>


<script>
    import {mapState} from 'vuex';
    import Popup from '@/components/modal/Popup.vue';
    import StaffGroup from '@/components/modal/rules/StaffGroup.vue';
    import RemoveStaffGroupError from '@/components/modal/rules/RemoveStaffGroupError.vue';
    import KickUnReadAll from '@/components/modal/rules/KickUnReadAll.vue';
	import PdfViewer from '@/components/modal/rules/PdfViewer.vue';
	import CreateUser from '@/components/modal/rules/CreateUser.vue';
    import AddWorker from '@/components/modal/rules/AddWorker.vue';
    import Tooltip from '@/components/Tooltip.vue';
    import draggable from '@/helpers/vuedraggable.js';
    import DismissWorker from '@/components/modal/rules/DismissWorker.vue';
    import RefuseWorker from '@/components/modal/rules/RefuseWorker.vue';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue';
    import Tumbler from '@/components/Tumbler.vue';
	import AsideSticky from '@/components/AsideSticky.vue';

    export default {
        metaInfo() {
            return {
                title: 'ПОЛЬЗОВАТЕЛИ',
                titleTemplate: this.$store.state.options.titleTemplate
            }
        },
        name: "Staff",
        components: {
            Popup,
            StaffGroup,
            RemoveStaffGroupError,
            Tooltip,
            draggable,
            AddWorker,
            DismissWorker,
            SubmitBtn,
            Tumbler,
            KickUnReadAll,
			AsideSticky,
			CreateUser,
			PdfViewer,
            RefuseWorker,
        },
        data: function(){
            return {
                drag: false,
                curDrugGroupIndex: 0,
                btnType: 'normal',
                kickUnReadAllBtnType: 'normal',
                kickActive: false,
				minHeight: false,
                usersHeight: false,
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                topSections: state => state.rules.topSectionsStaff,
                tumblers: state => state.rules.tumblers,
				canDrag: state => state.rules.canDrag,
                dismissUsers: state => state.rulesStaff.dismissUsers,
                refuseUsers: state => state.rulesStaff.refuseUsers,
                userCurrent: state => state.users.user,
            }),
            usersGroupedCurrentIndex(){
                return  this.$route.params.sid ? this.$route.params.sid : 0
            },
            usersGroupedCurrent(){
                let group = {
                    users: []
                };
                if(this.usersGroupedCurrentIndex == 'dismiss'){
                    group.users = this.dismissUsers;
                    group.name = 'Заблокированные';
                }
                else if(this.usersGroupedCurrentIndex == 'refuse'){
                    group.users = this.refuseUsers;
                    group.name = 'Отклоненные';
                } else {
                    for(let g in this.usersGrouped){
                        if(!group.id){
                            group = this.usersGrouped[g]
                        }
                        if(this.usersGrouped[g].id == this.usersGroupedCurrentIndex ){
                            group = this.usersGrouped[g]
                        }
                    }
                }

                return group
            },
            usersGrouped:{
                set(value) {
                    this.$store.dispatch('rulesStaff/setGroupSort', value);
                },
                get() {
                    return this.$store.state.rulesStaff.usersByDepartmentList;
                }
            },
            userTotal(){
                let total = 0;
                for(let g in this.usersGrouped){
                    total += this.usersGrouped[g].users.length
                }
                return total;
            }
        },
        methods:{
            addHeight(id, height) {
                this.minHeight += height;
            },
            removeHeight() {
                this.minHeight = this.usersHeight;
            },
            accessTitle(rights) {
              let titles = {
                'W': 'Редактор',
                'R': 'Читатель',
                'C': 'Модератор',
              }

              return titles[rights];
            },
            accessClass(rights) {
              let classes = {
                'W': 'editor',
                'R': 'reader',
                'C': 'chief',
              }

              return classes[rights];
            },
            setValue(value, index){
                let i = false
                for(let g in this.usersGrouped){
                    if(this.usersGrouped[g].id == index ){
                        i = g
                    }
                }
                if(i !== false){
                    this.$store.commit('rulesStaff/setUsersByDepartmentListByIndex', {
                        items: value,
                        index: i
                    });
                }
            },
            up: function(index){
                this.$store.dispatch('rulesStaff/setMoveGroup', {index: index, direction: 'up'});
            },
            down: function(index){
                this.$store.dispatch('rulesStaff/setMoveGroup', {index: index, direction: 'down'});
            },
            openStaffGroup: function (group = []) {
                this.$store.commit('rulesStaff/setEditGroup', group);
                this.$store.dispatch('popups/open', {name: this.popups.staffGroup.name});
            },
            openAddWorker: function (user = []) {
                this.$store.commit('rulesStaff/setEditUser', user);
                this.$store.dispatch('popups/open', {name: this.popups.addWorker.name});
            },
			openPdfViewer(){
				this.$store.dispatch('popups/open', {name: this.popups.pdfViewer.name});
			},
            dragSave: function (index) {
                if (this.drag) {
                    let i = false
                    for(let g in this.usersGrouped){
                        if(this.usersGrouped[g].id == index ){
                            i = g
                        }
                    }
                    if(i !== false){
                        this.$store.dispatch('rulesStaff/setUserSort', {index: i});
                    }

                    this.drag = false;
                }
            },
            dragSaveGrouped: function () {
                if (this.drag) {
                    this.drag = false;
                }
            },
            dragStart: function (index) {
                this.curDrugGroupIndex = index;
            },
            dragStatus: function (e) {
                this.drag = true;
            },
            kickUnRead(id, e){
                e.target.closest('.link-icon').classList.add('load');
                setTimeout(() => {
                    e.target.closest('.link-icon').classList.remove('load');
                }, 5000);
                this.$store.commit('rulesStaff/kickUnReadBtnType', {id: id,type: 'load'});
                this.$store.dispatch('rulesStaff/kickUnRead', {id: id}).then(()=>{
                    this.$store.commit('rulesStaff/kickUnReadBtnType', {id: id,type: 'normal'});
                });
            },
            kickUnReadAll(){
                this.kickUnReadAllBtnType = 'load';
                this.$store.dispatch('rulesStaff/kickUnReadAll').then(()=>{
                    this.kickUnReadAllBtnType = 'normal';
                });
            },
            openKickUnReadAll(){
                this.$store.commit('popups/open', {name: this.popups.kickUnReadAll.name});
            },
            clearFormUser(){
                this.$store.commit('rulesStaff/setUserForm', {})
            },
            setUsersGroupedCurrentIndex(index){
				if(!this.drag){
					window.scrollTo(0, 0);
                    if (this.$route.params.sid !== index) {
                        this.$router.push('/staff/'+index+'/');
                    }
				}
            }
        },
		watch: {
			usersGrouped(val){
				if(!this.usersHeight){
					this.$nextTick(() => {
						this.usersHeight = this.$refs.aside.getBoundingClientRect().height + 50;
                        this.minHeight = this.usersHeight;
					})
				}
			},

		},
        mounted() {
            if(!this.userCurrent.access_rights.is_owner && !this.userCurrent.is_can_dismiss && this.userCurrent.is_can_contract){
                this.$router.push('/staff/contract/')
            } else {
                this.$store.dispatch('rulesStaff/getUsersByDepartment');
                this.$store.dispatch('rules/getTopSection',{isStaffPage:true});
                this.$store.dispatch('contracts/getItems');
            }
        },
    }
</script>
